import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAppSelector } from '../../state/hooks';
import getTranslationByLangOrUk from '../../utils/getTranslationByLangOrUk';

interface SeoPops {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  noIndexPage?: boolean;
  keywords?: string;
  noFollow?: boolean;
  lang?: string;
}

function Seo({
  title, description, ogTitle, ogDescription, noFollow = false, noIndexPage = false, keywords, lang,
}: SeoPops) {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <Helmet>
      <title>{title || getTranslationByLangOrUk(interfaceLanguage, 'main_meta_title')}</title>
      <meta name="description" content={description || getTranslationByLangOrUk(interfaceLanguage, 'main_meta_description')} />
      <meta name="og:title" content={ogTitle || title || getTranslationByLangOrUk(interfaceLanguage, 'main_meta_title')} />
      <meta name="og:description" content={ogDescription || description || getTranslationByLangOrUk(interfaceLanguage, 'main_meta_description')} />
      <meta name="robots" content={`${noIndexPage ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`} />
      <html lang={lang} />
      {keywords && (
        <meta name="keywords" content={keywords} />
      )}
    </Helmet>
  );
}

export default Seo;
